<template>
    <div>
        <login-alert/>
        <register-alert/>
        <reset-password-alert/>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import LoginAlert from "cps/alerts/LoginAlert";
    import RegisterAlert from "cps/alerts/RegisterAlert";
    import ResetPasswordAlert from "cps/alerts/ResetPasswordAlert";

    export default {
        name: "index",
        components: {ResetPasswordAlert, LoginAlert, RegisterAlert},
        computed: {
            ...mapGetters(['globalMessage'])
        },
        watch: {
            globalMessage(n) {
                this.$bvModal.msgBoxConfirm(n.message, {
                    title: '提示',
                    size: 'sm',
                    buttonSize: 'sm',
                    okTitle: '确定',
                    cancelTitle: '关闭',
                    footerClass: 'p-2',
                    centered: true
                }).then(r => n.resolve(r));
            }
        }
    }
</script>

<style scoped>

</style>
